document.addEventListener("DOMContentLoaded", function () {
  const form = document.getElementById("reviewForm");
  const openReviewPopupBtn = document.getElementById('openReviewPopupBtn');
  const reviewPopupOverlay = document.getElementById('reviewPopupOverlay');
  const closePopupBtn = document.getElementById('closePopupBtn');
  const uploadInput = document.getElementById('upload_input');
  const fileList = document.getElementById('selected-files-list');
  const maxFiles = 3;

  let selectedFiles = [];

  function closePopup() {
    reviewPopupOverlay.style.display = 'none';
    document.body.style.overflow = 'auto';
  }

  openReviewPopupBtn?.addEventListener('click', () => {
    reviewPopupOverlay.style.display = 'flex';
    document.body.style.overflow = 'hidden';
  });

  closePopupBtn?.addEventListener('click', closePopup);

  reviewPopupOverlay?.addEventListener('click', (e) => {
    if (e.target === reviewPopupOverlay) {
      closePopup();
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' || e.key === 'Esc') {
      closePopup();
    }
  });

  uploadInput?.addEventListener('change', function () {
    const newFiles = Array.from(this.files);
    const totalFiles = selectedFiles.length + newFiles.length;

    if (totalFiles > maxFiles) {
      alert(`You can upload a maximum of ${maxFiles} files.`);
      this.value = '';
      return;
    }

    for (const file of newFiles) {
      if (!file.type.startsWith("image/") && !file.type.startsWith("video/")) {
        alert(`File "${file.name}" is not an image or video.`);
        return;
      }
      if (file.size > 2 * 1024 * 1024 * 1024) {
        alert(`File "${file.name}" is too large.`);
        return;
      }
    }

    selectedFiles = selectedFiles.concat(newFiles);
    fileList.innerHTML = '';
    selectedFiles.forEach((file) => {
      const li = document.createElement('li');
      li.textContent = file.name;
      fileList.appendChild(li);
    });

    this.value = '';
  });

  form?.addEventListener("submit", async function (event) {
    event.preventDefault();

    if (selectedFiles.length === 0) {
      alert("Please upload at least one file.");
      return;
    }

    const formData = new FormData(form);

    for (let i = 0; i < selectedFiles.length; i++) {
      formData.append('files', selectedFiles[i]);
    }

    const endpoint = "https://woofume-review-app-6ba6908c4961.herokuapp.com/review";

    try {
      const response = await fetch(endpoint, {
        method: "POST",
        body: formData,
      });

      const status = response.status;

      if (status === 201) {
        const resultText = await response.text();
        let result;

        try {
          result = JSON.parse(resultText);
        } catch (e) {
          console.warn("201 received but JSON could not be parsed:", resultText);
        }

        console.log("Success:", result || resultText);
        alert("Review submitted successfully!");

        form.reset();
        fileList.innerHTML = "";
        selectedFiles = [];
        closePopup();
      } else {
        const errorText = await response.text();
        console.error("Unexpected status:", status, errorText);
        alert(`Submission failed: ${status} - ${response.statusText}`);
      }
    } catch (error) {
      console.error("Network or CORS error:", error.message);
      alert("There was a network error submitting your review.");
      closePopup();
    }


  });
});
